<template>
    <div class="expositionCom exposition-chd">
        <div class="center">
            <!-- <home v-if="!changeMapBtn"/> -->
            <home  v-if="showMap" />
            <!-- <weixinMap ref="carsmap" v-if="showMap"/>       -->
			<!-- <Map2D v-if="!changeMapBtn" />
			<Map3D v-show="changeMapBtn" /> -->
            <changeing3D v-if="!changeMapBtn && !showMap"/>
			<!-- 2d/3d 切换 -->
			<!-- <div :class="changeMapBtn ? 'show2dBtn show3dBtn' : 'show2dBtn'" @click="clickMapBtn"></div> -->
		</div>
        <div class="chd-l-bg"></div>
        <div class="chd-r-bg"></div>
        <div class="com-left flex justify-between">
            <left-1 />
            <left-2 />
        </div>
        <div class="com-main pointerEvents flex justify-between">
            <goBack />
            <!-- <centerTop /> -->
            <center-1 />
            <center-2 />
        </div>
        <div class="com-right">
            <right-1 />
        </div>
    </div>
</template>

// <script>
// import Map2D from "@/views/vehicle/components/map/2dMap"
import Map3D from '@/views/vehicle/components/map/3dMap'
import home from '@/views/home'

import goBack from './../exposition/components/goBack'
import left1 from './../exposition/components/changingElectricity/left-1'
import left2 from './../exposition/components/changingElectricity/left-2'
import center1 from './../exposition/components/changingElectricity/center-1'
import center2 from './../exposition/components/changingElectricity/center-2'
// import centerTop from './../exposition/components/changingElectricity/center-top'
import right1 from './../exposition/components/changingElectricity/right-1'
import weixinMap from '@/views/components/weixinMap'
import changeing3D from '@/views/components/changeing3D'
export default {
    components: {
        goBack,
        left1,
        left2,
        center1,
        center2,
        // centerTop,
        right1,
        // Map2D,
        Map3D,
        home,
        weixinMap,
        changeing3D
    },
    data() {
        return {
            changeMapBtn: false,
            showBack: false,
            powerExchangeStation: 0, // 换
            chargingStation: 0, // 充
            pageInterval: null,
            intervalNum: 10,
            intervalNumSet: 10,
            showMap:false,
            localStorageData: localStorage.getItem('showMap') || '',
			end:false,
        }
    },
    watch: {
        // localStorageData(newData) {
		// // 数据发生变化时的回调函数
		// 	this.showMap = localStorage.getItem('showMap') == 'true' ? true : false
		// },
    },
    created(){
        this.showMap = localStorage.getItem('showMap') == 'true' ? true : false;
        console.log(this.showMap,'我存的数据');
    },
    mounted() {
		this.$EventBus.$on('isActiveEnd', (isActiveEnd) => {
			if (isActiveEnd) {
				this.end = false;
			} else {
				this.end = true;
			}
		})
        this.$bus.$on('showMap', () => {
            this.showMap = localStorage.getItem('showMap') == 'true' ? true : false;
        })
		document.title = '移动能源光储充换车云一体化大屏'
		let { fromUser, scaleY } = this.$route.query
		fromUser ? sessionStorage.setItem('fromUser', fromUser) : ''
		scaleY ? localStorage.setItem('bigScreen::scaleY', scaleY) : ''

		this.changeMapBtn = localStorage.getItem('SNECchangeMapBtn') == 'true' ? true : false

        if (this.$route.query && this.$route.query.province) {
      		console.log('省')
			this.adcode = this.$route.query.province;
			this.$EventBus.$emit('update', {
				province: this.adcode
			});
		} else if (this.$route.query && this.$route.query.city) {
      		console.log('市')
			this.adcode = this.$route.query.city;
			this.$EventBus.$emit('update', {
				city: this.adcode
			});
		} else if (this.$route.query && this.$route.query.district) {
      		console.log('区')
			this.adcode = this.$route.query.district;
			this.$EventBus.$emit('update', {
				district: this.adcode
			});
		} else {
      		console.log('省市区')
			this.type = 'nationwideSite'
			this.$EventBus.$emit('update', '');
		}

		let pathName = this.$route.name
		localStorage.setItem('exposition::pathName', pathName)

        this.pageInterval = null
        if(sessionStorage.getItem('fromUser') != 'guizhou') {
            this.pageInterval = setInterval(() => {
				if(this.end) return;
                this.intervalNum--
                if(this.intervalNum < 0 ) {
                    if(localStorage.getItem('IntervalStop') == 'stop') {
							return
						}
                    this.$router.replace({
                        path: 'powerStation',
                        query: {
                            stationId: 'd13e09fd3c89459789d3933008d4bcfa'
                        }
                    })
                }
            }, 1000)
            // document.onmousemove = ((event) => {
            //     // console.log(event)
            //     this.intervalNum = this.intervalNumSet
            // })
        }
    },
    methods: {
        // editData(data, type) {
        //     if(type) {
        //         this.chargingStation = data
        //     } else {
        //         this.powerExchangeStation = data
        //     }
        // },
        goback() {
            window.history.go(-1)
        },

		clickMapBtn() {
            this.showMap = !this.showMap;
            localStorage.setItem("showMap", this.showMap);
            this.$bus.$emit('showMap')
		},
    },
    destroyed() {
        clearInterval(this.pageInterval)
    }
}

</script>

<style lang="scss" scoped>
@import './components/scss/comm.scss';
.exposition-chd {
    position: relative;
    background: url('~@/assets/images/exposition/chd-bg.png');
    background-size: 100% 100%;
    .center {
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .chd-l-bg, .chd-r-bg {
        position: absolute;
        height: 100%;
        width: 1366px;
        opacity: 0.6;
    }
    .chd-l-bg {
        left: 0;
        background: url('~@/assets/images/exposition/chd-l-bg.png');
        background-size: 100% 100%;
    }
    .chd-r-bg {
        right: 0;
        background: url('~@/assets/images/exposition/chd-r-bg.png');
        background-size: 100% 100%;
        opacity: 0.5;
    }
}
</style>